export const deleteTraineeTask = (payload?: any) => ({
    type: "@saga/DELETE_TRAINEE_TASK",
    payload
});

